import { render, staticRenderFns } from "./logsTable.vue?vue&type=template&id=f0af0b8a&scoped=true"
import script from "./logsTable.vue?vue&type=script&lang=js"
export * from "./logsTable.vue?vue&type=script&lang=js"
import style0 from "./logsTable.vue?vue&type=style&index=0&id=f0af0b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0af0b8a",
  null
  
)

export default component.exports